var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
export const LeftBubble = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    return (React.createElement("svg", Object.assign({ width: "22", height: "24", viewBox: "0 0 22 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M5.5 17C4.46021 21.0942 0 24 0 24H22V0L6 7C6 7 6.26903 13.9719 5.5 17Z", fill: color })));
};
//# sourceMappingURL=LeftBubble.js.map